import { i18n as excursionNotFound } from "../components/ExcursionNotFound";
import en from "./en";
import es from "./es";

export default {
  en: { ...en, ...excursionNotFound.en },
  es: { ...es, ...excursionNotFound.es },
};
